import { gql } from '@apollo/client';

export const GetOrganizationGuestUsersSecurity = gql`
  query GetOrganizationGuestUsersSecurity($code: String!) {
    organizationGuestUsersSecurity(organizationCode: $code) {
      forceTotp
      forceEmail
    }
  }
`;
